<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >操作日志</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入姓名或信息"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column
                            field="edittype"
                            title="操作类型"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="edituser"
                            title="操作员"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="msg"
                            title="信息"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="createtime"
                            title="操作时间"
                            width="160"
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive } from "vue";
import { VXETable } from "vxe-table";

export default {
    name: "SysLogs",
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            formData: {
                searchKey: "",
            },
        });
        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            tableHeight: 0,
        };
    },
    methods: {
        launchToast(toastMsg) {
            this.$vaToast.init({
                message: toastMsg,
                iconClass: this.toastIcon,
                position: this.toastPosition,
                duration: Number(this.toastDuration),
                fullWidth: this.isToastFullWidth,
            });
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [this.toolbar.formData.searchKey],
            };
            this.$api.systemManageAPI
                .getSysLogsList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
